var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGreaterThan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26799_152927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.875 12.5875L3.875 13.7953C3.875 13.9 3.99531 13.9578 4.07656 13.8937L11.1203 8.39219C11.1802 8.34564 11.2286 8.28605 11.2619 8.21795C11.2952 8.14984 11.3125 8.07503 11.3125 7.99922C11.3125 7.9234 11.2952 7.84859 11.2619 7.78049C11.2286 7.71238 11.1802 7.65279 11.1203 7.60625L4.07656 2.10468C3.99375 2.04062 3.875 2.09843 3.875 2.20312L3.875 3.41093C3.875 3.4875 3.91094 3.56093 3.97031 3.60781L9.59531 7.99843L3.97031 12.3906C3.91094 12.4375 3.875 12.5109 3.875 12.5875Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26799_152927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreaterThan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/greater-than.077bd316.svg";
export { ForwardRef as ReactComponent };